import { render, staticRenderFns } from "./DocumentsSection.vue?vue&type=template&id=10dfb98e"
import script from "./DocumentsSection.vue?vue&type=script&lang=js"
export * from "./DocumentsSection.vue?vue&type=script&lang=js"
import style0 from "./DocumentsSection.vue?vue&type=style&index=0&id=10dfb98e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports